import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import TakePaymentModal from './TakePaymentModal';

interface Props {
  userId: string;
}

const TakePaymentCustomAmount: React.FC<Props> = ({ userId }) => {
  const [isModalOpen, setModalOpen] = useState(false);

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={() => setModalOpen(true)}
      >
        Take payment amount
      </Button>
      {isModalOpen ? (
        <TakePaymentModal userId={userId} onClose={() => setModalOpen(false)} />
      ) : null}
    </>
  );
};

export default TakePaymentCustomAmount;
